<template>
  <router-link :to="to" :class="classes">
    <slot />
    <span v-if="label">
      {{ $dictionary.get(label) }}
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'Anchor',
  props: {
    to: { type: [Object, String], required: true },
    dark: { type: Boolean, default: false },
    label: { type: String, default: null }
  },
  computed: {
    classes() {
      return {
        'anchor--dark': this.dark,
        'anchor--light': !this.dark
      };
    }
  },
};
</script>
